import { getNotifications } from '@/api/rest/activity-center'
import { SET_UNREAD_COUNT } from './mutationTypes'

const actions = {
  async fetchUnreadCount({ commit }) {
    const response = await getNotifications({
      read: false,
      pageSize: 200
    })

    const payload = response?.data ?? response

    const unreadCount = Number(
      payload?.totalElements
            ?? payload?.elements?.length
            ?? 0
    )

    commit(
      SET_UNREAD_COUNT,
      unreadCount
    )
  }
}

export default actions
